//write me a function to have following behavious:
// 1. if name BrandAssetsRemover/, want to remove the last / and return BrandAssetsRemover
//2.if name free_company_dataset.csv, want to return free_company_dataset.csv
//3. if name BrandAssetsRemover/Inbound/, want to remove the last / and return Inbound
//4. if name BrandAssetsRemover/Inbound/Inbound1/, want to remove the last / and return Inbound1
//5. if name BrandAssetsRemover/Inbound/TestFile_BrandAssetRemover.csv, want to return TestFile_BrandAssetRemover.csv
//give me the function
const getFolderName = (name: string) => {
  let folderName: string;
  if (name.endsWith("/")) {
    folderName = name.slice(0, -1).split("/").pop() as string;
  } else {
    folderName = name.split("/").pop() as string;
  }
  return folderName;
};

// function to covert 0001-01-01T00:00:00 to Ex: 01 May 2023 and if date not valid or null return null
const convertDate = (date: string) => {
  if (date === "0001-01-01T00:00:00") {
    return null;
  } else {
    return new Date(date).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
  }
};

//function to convert file size to KB, MB, GB
const convertFileSize = (size: number) => {
  if (size >= 1000000000) {
    return `${(size / 1000000000).toFixed(2)} GB`;
  } else if (size >= 1000000) {
    return `${(size / 1000000).toFixed(2)} MB`;
  } else if (size >= 1000) {
    return `${(size / 1000).toFixed(2)} KB`;
  } else {
    return null;
  }
};

function getExtension(filename: string | undefined) {
  if (!filename) return "";
  var parts = filename.split("/");
  return parts[parts.length - 1];
}

// give me function to alway remove backslash at the end of the string. Ex: Live Production/0001651121 - Joe Jay/01. Original/Email/ should return Live Production/0001651121 - Joe Jay/01. Original/Email, give me function:
function removeBackSlashAtTheEnd(name: string) {
  if (name.endsWith("/")) {
    return name.slice(0, -1);
  } else {
    return name;
  }
}
function handleDownload(link: { url: string; name: string }) {
  const a = document.createElement("a");
  a.href = link.url;
  a.download = link.name;
  a.click();
}

export { getFolderName, convertDate, convertFileSize, getExtension, removeBackSlashAtTheEnd, handleDownload };
